import React from 'react';
import { Card, Typography, TextField } from '@material-ui/core';


const RequestPromotionTitle = ({
  values,
  handleChange,
  handleBlur,
  touched,
  errors,
  classes
}) => {
  return (
    <Card className="p-5 mt-4" elevation={0}>
      <Typography variant="h5" className="font-bold mb-5">
        Title <span className="text-error">*</span>
      </Typography>
      <TextField
        required
        fullWidth
        variant="outlined"
        value={values.title}
        className={classes.no_margin}
        name="title"
        label="Promotion Title"
        onChange={handleChange}
        onBlur={handleBlur}
        error={touched.title && Boolean(errors.title)}
        helperText={touched.title && errors.title}
      />
    </Card>
  );
};

export default RequestPromotionTitle;
